// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qd-0";